export default __webpack_public_path__ + "static/media/announcement_2.f4b9c6a4.png";